import { AppBar, Box, Toolbar, Typography } from '@mui/material';

export function PublicHeader() {
  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar variant="dense">
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, paddingLeft: 1 }}>
            FAST AI
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
